import axios from 'axios'

export const UserApi = {
    async Table(data){
        const response = await axios.post('/api/user/table',data)
        return response
    },
    async CreateOrUpdate(update,data){
        const response = await axios.post(update ? '/api/user/update' : '/api/user/create' , data)
        return response
    },
    async Delete(data){
        const response = await axios.post(`/api/user/delete/${data}`)
        return response
    },
    async Disable(data){
        const response = await axios.post(`/api/user/disable/${data}`)
        return response
    },
    async ListWithoutSelectedUser(data){
        const response = await axios.post(`/api/user/list/withoutselecteduser`,data)
        return response
    },
    async List(){
        const response = await axios.get(`/api/user/salesman/list`)
        return response
    },
    async ResendConfirmationCode(data){
        const response = await axios.post(`/api/user/resendconfirmationcode/${data}`)
        return response
    },
    // Yonetici tarafindan baslatilan parola sifirlama: ilgili kullaniciya sifirlama
    // baglantisi gider. Yeni parolayi kullanicinin kendisi belirler.
    async SendPasswordResetLink(data){
        const response = await axios.post(`/api/user/sendpasswordresetlink/${data}`)
        return response
    },
    async Confirm(code){
        // Aktivasyon anonim bir islemdir. Tarayicida duran eski/gecersiz bir token
        // gonderilirse istek gereksiz yere 401'e dusup login'e yonlendirilebiliyor.
        // Bu yuzden istek Authorization header'i olmadan gonderiliyor.
        const response = await axios.post(`/api/user/confirm/${encodeURIComponent(code)}`, null, {
            transformRequest: [function stripAuthorization(data, headers){
                if(headers){
                    if(headers.common) delete headers.common.Authorization
                    if(headers.post) delete headers.post.Authorization
                    delete headers.Authorization
                }
                return data
            }]
        })
        return response
    },
    async CurrentUserProfile(){
        const response = await axios.get(`/api/user/get/currentuserinformation`)
        return response
    },
    async UpdatePassword(data){
        const response = await axios.post('/api/user/update/password',data)
        return response
    },
    async SalesmanList(){
        const response = await axios.get(`/api/user/salesman/list`)
        return response
    }
}